import React, { useContext } from "react";
import classes from "./Blog.module.css";
import BlogItem from "./blogItem/BlogItem";
import { BlogDetails } from "./BlogDetails";
import { ThemeContext } from "../../ThemeProvider";
import Reveal from "react-awesome-reveal";
import { keyframes } from "@emotion/react";

const customAnimation = keyframes`
  from {
    opacity: 0;
    transform: translateY(40px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Blog = () => {
  const { dark } = useContext(ThemeContext);

  return (
    <Reveal
      keyframes={customAnimation}
      triggerOnce="true"
      duration={1000}
      fraction={0.2}
    >
      <section
        className={
          dark ? `${classes.blog} ${classes.blog__dark}` : classes.blog
        }
        id="blog"
      >
        <div
          className={
            dark
              ? `${classes.blog__title} ${classes.blog__title__dark}`
              : classes.blog__title
          }
        >
          <h1>
            <span
              className={
                dark
                  ? `${classes.blog__title__num} ${classes.blog__title__num__dark}`
                  : classes.blog__title__num
              }
            >
              04.
            </span>{" "}
            Things I've written{" "}
          </h1>
          <div className={classes.blog__line}></div>
        </div>

        <div className={classes.blog__item}>
          {BlogDetails.map((blog) => (
            <BlogItem
              title={blog.title}
              desc={blog.desc}
              link={blog.link}
              key={blog.title}
            />
          ))}
        </div>
      </section>
    </Reveal>
  );
};

export default Blog;
